import { render, staticRenderFns } from "./AdminNavigationItems.vue?vue&type=template&id=1c5cfec0"
import script from "./AdminNavigationItems.vue?vue&type=script&lang=js"
export * from "./AdminNavigationItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports